import React from 'react'
import { useTranslation } from 'react-i18next'

const SendAddressCard = ({ sendAddress }) => {

  const { t } = useTranslation();

  return (
    <div>
      <div className='row justify-content-center'>
        <div className='justify-content-center mt-2'>
          <div>
            <div className='panel-header-title'>{t('shippind_details')}</div>
            <div className='col-auto ms-1'>
              {sendAddress.deliveryName} <br />
              {sendAddress.deliveryContact} <br />
              {sendAddress.addressStreet} <br />
              {sendAddress.addressZipCity} <br />
              {sendAddress.deliveryEmail ? 'E-mail: ' + sendAddress.deliveryEmail : ''}<br />
              {sendAddress.deliveryPhone ? t("phone") + ': ' + sendAddress.deliveryPhone : ''}<br />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SendAddressCard